<template>
	<nav v-if="data" class="navbar navbar-default navbar-custom">
		<div class="container-fluid bold-400">
			<div class="navbar-header navbar-header-custom">
				<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
					<span class="sr-only">Toggle navigation</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
				<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/deliverynotes/' + data.id" class="navbar-brand navbar-brand-custom bold">
					Albarán {{ $platform.setting.number_symbol }}{{ data.id }}
				</router-link>
			</div>

			<div class="collapse navbar-collapse navbar-collapse-custom" id="bs-example-navbar-collapse-1">
				<ul class="nav navbar-nav">
					<li :class="'list-group-item-' + data.status.class">
						<a @click="$refs.ChangeStatus.open(data)" href="javascript:void(0)">
							<span v-html="data.status.icon"></span>
							<template v-if="data.status.lang">
								{{ data.status.lang.name }}
							</template>
							<template v-else>
								{{ data.status.name }}
							</template>
						</a>
					</li>
					<template v-if="data.customer">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/customers/' + data.customer.id" :title="data.customer.name">
								<i class="fa fa-address-card-o" aria-hidden="true"></i>
								Cliente {{ $platform.setting.number_symbol }}<template v-if="$platform.setting.customers.custom_reference">{{ data.customer.reference }}</template><template v-else>{{ data.customer.id }}</template>
							</router-link>
						</li>
					</template>
					<template v-if="data.order">
						<li>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + data.order.id">
								<i class="fa fa-file-text" aria-hidden="true"></i>
								Pedido {{ $platform.setting.number_symbol }}{{ data.order.id }}
							</router-link>
						</li>
					</template>
				</ul>
				<ul class="nav navbar-nav navbar-right">
					<template v-if="data.delivery_note_status_id == 1">
						<li>
							<a @click="$refs.ChangePlace.open(data)" href="javascript:void(0)">
								<i class="fa fa-map-marker" aria-hidden="true"></i>
								<span class="visible-xs visible-xs-navbar">
									Dirección de entrega
								</span>
							</a>
						</li>
					</template>
					<li v-if="canPirnt()">
						<a @click="doPrint()" href="javascript:void(0)">
							<i class="fa fa-print" aria-hidden="true"></i>
							<span class="visible-xs visible-xs-navbar">
								{{ $t('interface.print') | ucfirst }}
							</span>
						</a>
					</li>
					<li>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/management/deliverynotes/' + data.random" target= '_blank'>
							<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
							<span class="visible-xs visible-xs-navbar">
								Ver PDF
							</span>
						</router-link>
					</li>
				</ul>
			</div>
		</div>

		<fab
			:type="type"
			:data="data"
			:user="user"
			:isAuth="isAuth"
			@reload="reload">
		</fab>

		<change-status
			@reload="reload"
			ref="ChangeStatus"
			:user="user"
			:isAuth="isAuth">
		</change-status>

		<change-place
			@reload="reload"
			ref="ChangePlace"
			:user="user"
			:isAuth="isAuth">
		</change-place>
	</nav>
</template>

<script>
	import swal from 'sweetalert2'
	import Fav from './Fab'
	import ChangeStatus from './ChangeStatus'
	import ChangePlace from './ChangePlace'

	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		components: {
			'fab': Fav,
			'change-status': ChangeStatus,
			'change-place': ChangePlace,
		},
		data () {
			return {

			}
		},
		computed: {
			hasProviders() {
				var has = false
				if(this.data) {
					if(this.data.products) {
						if(this.data.products.length) {
							for (var i = 0; i < this.data.products.length; i++) {
								var product = this.data.products[i]
								if(product.provider_id) {
									has = true
									break;
								}
							}
						}
					}
				}
				return has
			},
			canGenerateOrders() {
				var can = false

				if(this.data) {
					if(this.data.providers) {
						if(this.data.providers.length) {
							for (var i = this.data.providers.length - 1; i >= 0; i--) {
								var provider = this.data.providers[i]
								if(provider.product_storages) {
									if(provider.product_storages.length) {
										for (var k = provider.product_storages.length - 1; k >= 0; k--) {
											var product = provider.product_storages[k]

											if(!product.order_provider_id) {
												var can = true
											}
										}
									}
								}
							}
						}
					}
				}

				return can
			}
		},
		methods: {
			reload() {
				this.$emit('reload')
			},
			//--
			doPrint() {
				$(".printableArea").printThis({
					canvas: true,
				})
			},
			canPirnt() {
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.name) {
							if(this.$route.meta.name == 'show') {
								return true
							}
						}
					}
				}

				return false
			},
			lock() {
				var that = this
				if(this.data.lock) {
					var title = 'Pedido bloqueado'
					var text = '¿Desbloquear?'
					var type = 'info'

					var api = 'admin/management/orders/' + that.data.id + '/unlock'
				} else {
					var title = 'Pedido sin bloquear'
					var text = '¿Bloquear?'
					var type = 'info'

					var api = 'admin/management/orders/' + that.data.id + '/lock'
				}
				swal.queue([{
						title: title,
						text: text,
						type: type,
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							that.loading = true
							return new Promise(function (resolve) {
								that.$http.get(api)
								.then(response => {
									that.loading = false
									var path = '/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/orders/' + that.data.id
									if(that.$route.fullPath != path) {
										that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/orders/' + that.data.id)
									} else {
										that.reload()
									}
									swal({
										title: response.body.title,
										text: response.body.text,
										type: response.body.type,
									})
								}).catch(function(response) {
									console.log(response)
									that.loading = false
									that.reload()
								})
							})
						}
					}]).catch(swal.noop)
			},
			generateInvoice() {
				var that = this
				var tax_id = this.$platform.setting.tax_id
				if(this.data.tax_id) {
					var tax_id = this.data.tax_id
				}

				var data = {
					customer_id: this.data.customer_id,
					provider_id: this.data.provider_id,
					budget_id: this.data.budget_id,
					order_id: this.data.id,
					project_id: this.data.project_id,
					tax_id: tax_id,
				}

				if(data.customer_id) {
					swal.queue([{
						title: that.$t("messages.attention"),
						text: "Se añadirá una factura de venta",
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							return new Promise(function (resolve) {
								that.$http.post('admin/management/invoices', data)
								.then(response => {
									that.reload()
									swal(response.body.title, response.body.text, response.body.type);
								}).catch(function(response) {
									if(response.status == 409) {
										swal(response.body.title, response.body.text, response.body.type);
									} else {
										swal({
											title: response.statusText,
											text: response.body,
											type: "warning"
										});
									}
								})
							})
						}
					}]).catch(swal.noop)
				} else {
					if(data.provider_id) {
						swal.queue([{
							title: that.$t("messages.attention"),
							text: "Se añadirá una factura de compra",
							type: "warning",
							input: 'text',
							inputPlaceholder: 'Nº Factura',
							showCancelButton: true,
							confirmButtonColor: "#53e69d",
							cancelButtonColor: "#ff7676",
							confirmButtonText: "Si",
							cancelButtonText: "No",
							showLoaderOnConfirm: true,
							preConfirm: function (number_invoice_provider) {
								return new Promise(function (resolve) {
									if(number_invoice_provider) {
										data.number_invoice_provider = number_invoice_provider
									}
									that.$http.post('admin/management/invoices', data)
									.then(response => {
										that.reload()
										swal(response.body.title, response.body.text, response.body.type);
									}).catch(function(response) {
										if(response.status == 409) {
											swal(response.body.title, response.body.text, response.body.type);
										} else {
											swal({
												title: response.statusText,
												text: response.body,
												type: "warning"
											});
										}
									})
								})
							}
						}]).catch(swal.noop)
					}
				}
			},
			openCreateSchedule(item) {
				this.$refs.schedulecreate.item = item
				this.$refs.schedulecreate.open(this.data)
			},
			openTaskCreate(data) {
				this.$refs.taskCreate.open(data, null, null, this.data)
			},
			generateOrders() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.purchase_orders_will_be_added"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/management/orders/' + that.data.id + '/generate/orders')
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type)
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
			//--
			changeStatus(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				if(this.data.status.id) {
					this.$http.get('admin/management/budgets/' + this.data.id + '/change/status/' + this.data.status.id)
						.then(response => {
							select.removeAttribute('disabled')
							this.reload()
						}).catch(response => {
							select.removeAttribute('disabled')
							if(response.status == 409) {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
							this.reload()
						})
				}
			},
			openGenerateOrderProvider(product, provider) {
				this.$refs.GenerateOrderProvider.open(product, provider)
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/management/deliveryNotes/views/Navbar.vue